export const copyText = (value: any) => {
  navigator.clipboard
    .writeText(value)
    .then(() => console.log('[*]', 'Copied!'))
    .catch((error) => console.error(error));
};